import Axios from 'axios'

import {
    standardizeCart,
} from '@/services/Standardizers'

import { log } from '@/services/Log'


import { generateLineItemsFromCheckout } from './generateLineItemsFromCheckout'


export const getCart = async () => {
    log('getCart START')
    // Returns a Cart. - https://developer.bigcommerce.com/api-reference/storefront/carts/cart/getacart
    const { data } = await Axios.get('/api/storefront/cart?include=lineItems.physicalItems.options')
    const rawCart = Array.isArray(data) ? data[0] : data
    if (!rawCart) {
        return null
    }

    // Adds isFurniture boolean property and availability message to lineItems
    let lineItems = await generateLineItemsFromCheckout(rawCart)
    const cart = standardizeCart({ ...rawCart, lineItems })
    log('getCart END', { cart })
    return cart
}